import { useEffect, useState } from "react";
const useDebounce = ({ value, delay = 500, shouldbeDebounced = true }) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const timer = shouldbeDebounced
            ? setTimeout(() => {
                setDebouncedValue(value);
            }, delay)
            : setDebouncedValue(value);
        return () => {
            return timer ? clearTimeout(timer) : null;
        };
    }, [value, delay]);
    const debounceFn = (fn) => {
        let timer;
        const executedFunction = (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                fn.apply(this, args);
            }, delay);
        };
        executedFunction.abort = () => {
            clearTimeout(timer);
        };
        return executedFunction;
    };
    return {
        debouncedValue,
        debounceFn
    };
};
export default useDebounce;
